import CollectionFilters from "./modules/CollectionFilters";
import { CONSTRUCTOR_COLLECTION_FALLBACK_ATTRIBUTE } from "./modules/external-systems/constructor.io/widgets/collection/mode";
import { loadShopifyCollectionFallback } from "./modules/external-systems/constructor.io/widgets/collection/fallback";
import { markShopifyCollectionModulesReady } from "./modules/external-systems/constructor.io/widgets/collection/shopify";
import CustomSelect from "./modules/CustomSelect";
//import Slider from "./modules/Slider"
import * as Filters from "./modules/Filters"
import CollectionPagination from "./modules/CollectionPagination"
import CollectionBannersTest from "./modules/CollectionBannersTest"
// import SortingOptimizer from "./modules/external-systems/dynamic-yield/SortingOptimizer"
// import "./apps-react/AppMain"
// import "./modules-react___old/CollectionFilters/CollectionFilters"
const $_selects = [...document.querySelectorAll('[data-gld-select="root"]')];
const collectionScrollStorageKey = 'gld_collection_scroll_position';
let collectionPagination = null;
let paginationObserver = null;

function getCollectionScrollStateKey() {
    return `${window.location.pathname}${window.location.search}`;
}

function saveCollectionScrollPosition(link) {
    const product = link.closest('[data-collection-product-item]');
    const productId = product?.dataset?.productId;

    if (!productId) {
        return;
    }

    try {
        sessionStorage.setItem(collectionScrollStorageKey, JSON.stringify({
            key: getCollectionScrollStateKey(),
            productId,
        }));
    } catch (error) {}
}

function restoreCollectionScrollPosition() {
    try {
        const state = JSON.parse(sessionStorage.getItem(collectionScrollStorageKey));

        if (!state || state.key !== getCollectionScrollStateKey() || !state.productId) {
            return;
        }

        sessionStorage.removeItem(collectionScrollStorageKey);

        requestAnimationFrame(() => {
            document
                .querySelector(`[data-collection-product-item][data-product-id="${state.productId}"]`)
                ?.scrollIntoView({ block: 'center' });
        });
    } catch (error) {}
}

function initCollectionScrollRestoration() {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('[data-collection-products] [data-product-card-link]');

        if (!link) {
            return;
        }

        const url = new URL(link.href, window.location.origin);

        if (url.origin === window.location.origin && url.pathname.includes('/products/')) {
            saveCollectionScrollPosition(link);
        }
    }, true);

    window.addEventListener('pageshow', restoreCollectionScrollPosition);
}

function initCollectionPagination() {
    const pagination = document.querySelector('[data-collection-products] [data-pagination-wrapper]')

    if (collectionPagination) {
        collectionPagination.refresh();
        return;
    }

    if (!pagination) {
        return;
    }

    collectionPagination = new CollectionPagination();
    paginationObserver?.disconnect();
}

new CollectionFilters();
new CollectionBannersTest();
if ($_selects.length) {
    new CustomSelect($_selects);
}
initCollectionScrollRestoration();
initCollectionPagination();

if (!collectionPagination && window.MutationObserver) {
    paginationObserver = new MutationObserver(initCollectionPagination);

    paginationObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
}

/**
 * A collection that fell back belongs to Shopify again, but Liquid keeps
 * rendering the Constructor stand-in: a page fetched by `CollectionPagination`
 * or a filtered grid rendered by `Filters.js` arrives in that undecided state
 * again. A/B mode can reveal its full grid synchronously; forced mode starts
 * the AJAX restoration of the Shopify cards from the same hooks.
 */
function restoreFallenBackCollections() {
    document
        .querySelectorAll(`[${CONSTRUCTOR_COLLECTION_FALLBACK_ATTRIBUTE}]`)
        .forEach((widget) => {
            loadShopifyCollectionFallback(
                widget,
                widget.getAttribute(CONSTRUCTOR_COLLECTION_FALLBACK_ATTRIBUTE)
            );
        });
}

window.callbacks_pagination_after_change =
    window.callbacks_pagination_after_change || [];
window.callbacks_pagination_after_change.push(restoreFallenBackCollections);

window.callbacks_filters_after_render_products =
    window.callbacks_filters_after_render_products || [];
window.callbacks_filters_after_render_products.push(restoreFallenBackCollections);

document.addEventListener('shopify:section:load', initCollectionPagination);
document.addEventListener('shopify:section:select', initCollectionPagination);

// The Constructor.io collection widget generates its own pagination wrappers
// in place of the Liquid ones, so `CollectionPagination` has to look at the
// collection again: it is what shows the wrapper matching the configured
// pagination system and what re-arms the automatic "load more" observer.
document.addEventListener('constructorio:collection:loaded', initCollectionPagination);
document.addEventListener('constructorio:collection:fallback', initCollectionPagination);

markShopifyCollectionModulesReady();

// new SortingOptimizer();
